"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Select2 = _interopRequireDefault(require("@material-ui/core/Select"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _ArrowDropDownIcon = _interopRequireDefault(require("./ArrowDropDownIcon"));

var _Input = _interopRequireDefault(require("../input/Input"));

var _Select3 = _interopRequireDefault(require("./Select.styles"));

var Select = /*#__PURE__*/(0, _react.forwardRef)(function Select(props, ref) {
  var className = props.className,
      label = props.label,
      intent = props.intent,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "label", "intent"]);
  var classes = (0, _Select3.default)();
  return /*#__PURE__*/_react.default.createElement(_Select2.default, Object.assign({}, rest, {
    className: (0, _classnames.default)('pds-select', className, {
      'Mui-warning': intent === 'warning'
    }),
    classes: classes,
    intent: intent,
    IconComponent: _ArrowDropDownIcon.default,
    input: /*#__PURE__*/_react.default.createElement(_Input.default, null),
    ref: ref,
    native: true
  }));
});
Select.propTypes = {
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: _propTypes.bool,

  /**
   * The option elements to populate the select with.
   */
  children: _propTypes.node,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.string,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: _propTypes.any,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.bool,

  /**
   * The id of the `select` element.
   */
  id: _propTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select#Attributes) applied to the `select` element.
   */
  inputProps: _propTypes.object,

  /**
   * If it should have the `error`, `warning` or default styles.
   */
  intent: (0, _propTypes.oneOf)([undefined, 'error', 'warning']),

  /**
   * The idea of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: _propTypes.string,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _propTypes.bool,

  /**
   * Callback fired when the input is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: _propTypes.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   */
  onChange: _propTypes.func,

  /**
   * The input value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: _propTypes.any
};
var _default = Select;
exports.default = _default;
